import {ClayInput} from '@clayui/form';
import BaseWrapper from "../BaseWrapper";
import React, {useCallback} from "react";
import {Controller, useFormContext} from 'react-hook-form';

type FormInputProps = {
    name: string;
    label?: string;
    type?: string;
    readonly?: boolean;
    disabled?: boolean;
    groupClassName?: string;
    className?: string;
    required?: boolean;
    placeholder?: string;
    textNumberInput?: boolean;
    min?: number;
    max?: number;
    maxDigits?: number;
    allowDecimal?: boolean;
};

export function FormInputText(props: FormInputProps) {
    const { formState } = useFormContext();

    const formatToNumber = useCallback((value: string): string => {
        let digits = props.allowDecimal
            ? value.replace(/[^\d.]/g, '')
            : value.replace(/\D/g, '');
        const parts = digits.split('.');
        if (parts.length > 2) {
            digits = parts[0] + '.' + parts.slice(1).join('');
        }
        if (props.maxDigits && digits.length > props.maxDigits) {
            return `${digits.slice(0, props.maxDigits)}`;
        }
        return digits;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Controller
            name={props.name}
            render={({field, fieldState}) => (
                <BaseWrapper
                    error={fieldState?.error?.message}
                    id={props.name}
                    label={props.label}
                    required={props.required}
                    groupClassName={props.groupClassName}
                >
                    <ClayInput
                        id={props.name}
                        name={props.name}
                        component={props.type === 'textarea' ? 'textarea' : 'input'}
                        value={field.value??''}
                        placeholder={props.placeholder}
                        className='text-ellipsis'
                        type={props.type}
                        readOnly={props.readonly}
                        min={props.min ? props.min : undefined}
                        max={props.max ? props.max : undefined}
                        disabled={props.disabled || formState.isLoading}
                        onChange={(e) => field.onChange((props.textNumberInput || props.type === 'number')
                            ? formatToNumber(e.target.value)
                            : (e.target.value.startsWith(' ') ? e.target.value.trimStart() : e.target.value))}
                        required={props.required}
                    />
                </BaseWrapper>
            )}
        />
    );
}
